import { useState } from 'react';
import TextField from '@mui/material/TextField';
import useGetPlaces from '@/hooks/use-get-places';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { map } from 'lodash';
import { useTranslate } from 'react-admin';

interface Props {
    setViewState: any;
}

const PlacesAutocomplete = ({ setViewState }: Props) => {
    const [textQuery, setTextQuery] = useState<string>('');
    const [isFocused, setIsFocused] = useState<boolean>(false);
    const translate = useTranslate();

    const { places } = useGetPlaces({ textQuery });

    const handleInputChange = ({ target: { value } }: any) => {
        setTextQuery(value);
    };

    const handleSelectListOption = (place: any) => {
        setTextQuery(place.formattedAddress);
        setViewState({ ...place.location, zoom: 16 });
    };

    return (
        <Box
            sx={{
                position: 'relative',
            }}
        >
            <TextField
                label={translate('placesAutocomplete.inputLabel')}
                variant='standard'
                fullWidth
                value={textQuery}
                onChange={handleInputChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => {
                    setTimeout(() => {
                        setIsFocused(false);
                    }, 100);
                }}
            />

            {isFocused && (
                <List
                    sx={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        bgcolor: 'white',
                        boxShadow: 2,
                        zIndex: 1,
                        maxHeight: 300,
                        overflowY: 'auto',
                        borderBottomLeftRadius: 5,
                        borderBottomRightRadius: 5,
                        p: 0,
                    }}
                >
                    {map(places, (place) => (
                        <ListItem key={place.id} disablePadding onClick={() => handleSelectListOption(place)}>
                            <ListItemButton>
                                <ListItemText primary={place.formattedAddress} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            )}
        </Box>
    );
};

export default PlacesAutocomplete;
